import { SimpleChanges } from '@angular/core';
import { Session } from '../../../shared/model/session.model';
import { UserService } from '../../../core/user/user.service';
import { SessionService } from '../../session/session.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CancelSessionDialogComponent } from '../../session/cancel-session-dialog/cancel-session-dialog.component';
import { Router } from '@angular/router';
import { AccountService } from '../../../core/auth/account.service';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { RateSessionComponent } from '../../../shared/rate/rate-session.component';
import * as momenttz from "moment-timezone";
import { SessionStatusManagerService } from '../../../core/session/session-status-manager.service';
import { JhiLanguageService } from '../../../ng-jhipster/language';
import * as i0 from "@angular/core";
import * as i1 from "@ng-bootstrap/ng-bootstrap";
import * as i2 from "../../session/session.service";
import * as i3 from "../../../core/user/user.service";
import * as i4 from "@angular/router";
import * as i5 from "../../../core/auth/account.service";
import * as i6 from "../../../core/tracker/tracker.service";
import * as i7 from "../../../ng-jhipster/language";
import * as i8 from "../../../core/session/session-status-manager.service";
import * as i9 from "@angular/common";
import * as i10 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i11 from "@fortawesome/angular-fontawesome";
import * as i12 from "@angular/material/tooltip";
import * as i13 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i14 from "../../../shared/calendar/add-to-calendar.component";
import * as i15 from "@ngx-translate/core";
import * as i16 from "../../../shared/language/find-flag-code-from-key.pipe";
import * as i17 from "../../../shared/language/find-language-from-key.pipe";
function SessionInfoCardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "h3", 5);
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵelement(3, "img", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelement(7, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 11);
    i0.ɵɵelement(9, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 13);
    i0.ɵɵelement(11, "img", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 14);
    i0.ɵɵelementStart(13, "div", 15);
    i0.ɵɵelementStart(14, "button", 16);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_1_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.scheduleSession(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SessionInfoCardComponent_div_2_div_40_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 47);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_2_div_40_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(3); return ctx_r14.cancelSession(ctx_r14.session.id, "cancel"); });
    i0.ɵɵelementEnd();
} }
function SessionInfoCardComponent_div_2_div_40_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 48);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_2_div_40_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return ctx_r16.rescheduleSession(ctx_r16.session.id); });
    i0.ɵɵelementEnd();
} }
function SessionInfoCardComponent_div_2_div_40_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 48);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_2_div_40_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(3); return ctx_r18.rescheduleSession(ctx_r18.session.id); });
    i0.ɵɵelementEnd();
} }
function SessionInfoCardComponent_div_2_div_40_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 47);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_2_div_40_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(3); return ctx_r20.cancelSession(ctx_r20.session.id, "cancel"); });
    i0.ɵɵelementEnd();
} }
function SessionInfoCardComponent_div_2_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "div", 43);
    i0.ɵɵtemplate(2, SessionInfoCardComponent_div_2_div_40_button_2_Template, 1, 0, "button", 44);
    i0.ɵɵtemplate(3, SessionInfoCardComponent_div_2_div_40_button_3_Template, 1, 0, "button", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 46);
    i0.ɵɵtemplate(5, SessionInfoCardComponent_div_2_div_40_button_5_Template, 1, 0, "button", 45);
    i0.ɵɵtemplate(6, SessionInfoCardComponent_div_2_div_40_button_6_Template, 1, 0, "button", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.session.cancellable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.session.rescheduleable);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.session.rescheduleable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.session.cancellable);
} }
function SessionInfoCardComponent_div_2_div_41_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 53);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_2_div_41_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(3); return ctx_r26.rescheduleSession(ctx_r26.session.id); });
    i0.ɵɵelementEnd();
} }
function SessionInfoCardComponent_div_2_div_41_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 54);
} }
function SessionInfoCardComponent_div_2_div_41_fa_icon_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 54);
} }
function SessionInfoCardComponent_div_2_div_41_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 53);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_2_div_41_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(3); return ctx_r28.rescheduleSession(ctx_r28.session.id); });
    i0.ɵɵelementEnd();
} }
function SessionInfoCardComponent_div_2_div_41_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "div", 43);
    i0.ɵɵtemplate(2, SessionInfoCardComponent_div_2_div_41_button_2_Template, 1, 0, "button", 49);
    i0.ɵɵelementStart(3, "button", 50);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_2_div_41_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.goToSessionChat(ctx_r30.session); });
    i0.ɵɵtemplate(4, SessionInfoCardComponent_div_2_div_41_fa_icon_4_Template, 1, 0, "fa-icon", 51);
    i0.ɵɵelement(5, "span", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 46);
    i0.ɵɵelementStart(7, "button", 50);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_2_div_41_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.goToSessionChat(ctx_r32.session); });
    i0.ɵɵtemplate(8, SessionInfoCardComponent_div_2_div_41_fa_icon_8_Template, 1, 0, "fa-icon", 51);
    i0.ɵɵelement(9, "span", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, SessionInfoCardComponent_div_2_div_41_button_10_Template, 1, 0, "button", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.session.rescheduleable);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.session.type === "video");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.join " + ctx_r8.session.type);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r8.session.type === "video");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.join " + ctx_r8.session.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.session.rescheduleable);
} }
function SessionInfoCardComponent_div_2_div_42_fa_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 54);
} }
const _c0 = function (a0) { return { coachLogin: a0 }; };
function SessionInfoCardComponent_div_2_div_42_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "div", 55);
    i0.ɵɵelement(2, "span", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 46);
    i0.ɵɵelementStart(4, "button", 50);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_2_div_42_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.goToSessionChat(ctx_r34.session); });
    i0.ɵɵtemplate(5, SessionInfoCardComponent_div_2_div_42_fa_icon_5_Template, 1, 0, "fa-icon", 51);
    i0.ɵɵelement(6, "span", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(3, _c0, ctx_r9.session != null ? ctx_r9.session.coachLogin : ctx_r9.endedSessions[0].coachLogin));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r9.session.type === "video");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.join " + ctx_r9.session.type);
} }
const _c1 = function (a0) { return { "margin-top": a0 }; };
function SessionInfoCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "h3", 18);
    i0.ɵɵelementStart(2, "div", 19);
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵelement(4, "span", 21);
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "span", 23);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 24);
    i0.ɵɵelementStart(10, "ngb-rating", 25);
    i0.ɵɵlistener("rateChange", function SessionInfoCardComponent_div_2_Template_ngb_rating_rateChange_10_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.session.coachScore = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 26);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 20);
    i0.ɵɵelement(15, "span", 27);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(16, "svg", 28);
    i0.ɵɵelement(17, "use", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(18, "span", 30);
    i0.ɵɵelement(19, "fa-icon", 31);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 32);
    i0.ɵɵelement(22, "span", 33);
    i0.ɵɵelement(23, "ngx-emoji", 34);
    i0.ɵɵpipe(24, "findFlagCodeFromKey");
    i0.ɵɵelementStart(25, "span", 35);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "findLanguageFromKey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 20);
    i0.ɵɵelement(29, "span", 36);
    i0.ɵɵelementStart(30, "span", 23);
    i0.ɵɵtext(31);
    i0.ɵɵpipe(32, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 20);
    i0.ɵɵelement(34, "span", 37);
    i0.ɵɵelementStart(35, "div", 38);
    i0.ɵɵelementStart(36, "span", 39);
    i0.ɵɵtext(37);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(38, "add-to-calendar", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 41);
    i0.ɵɵtemplate(40, SessionInfoCardComponent_div_2_div_40_Template, 7, 4, "div", 42);
    i0.ɵɵtemplate(41, SessionInfoCardComponent_div_2_div_41_Template, 11, 6, "div", 42);
    i0.ɵɵtemplate(42, SessionInfoCardComponent_div_2_div_42_Template, 7, 5, "div", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r1.session.coachLogin);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("rate", ctx_r1.session.coachScore)("starTemplate", _r3)("readonly", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 20, ctx_r1.session.coachScore, "1.0-1"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(31, _c1, ctx_r1.session.type === "video" ? "6px" : "4px"));
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("href", "../../../../content/images/sprite.svg?v=3#" + ctx_r1.session.type, null, "xlink");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("jhiTranslate", "sessionSchedule.paragraph." + ctx_r1.session.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(20, 23, "inukaNgApp.indexUser.sessionInfoCard." + ctx_r1.session.type + "Info"))("matTooltipPosition", "right")("matTooltipClass", "info-tool-tip");
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(24, 25, ctx_r1.session.langKey), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 27, ctx_r1.session.langKey));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(32, 29, ctx_r1.session.sessionStartTime.locale(ctx_r1.languageService.getCurrentLanguage()).format("ddd, DD MMMM").replace(".", "")), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.session.sessionStartTime.tz(ctx_r1.timezone).format("hh:mm a zz") + ", " + ctx_r1.session.duration + " min |", " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("session", ctx_r1.session);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r1.getDisplayBlockForButtons());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "FUTURE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "ACTIVE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "STARTED");
} }
function SessionInfoCardComponent_div_3_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 64);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_3_button_14_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(2); return ctx_r39.openRating(); });
    i0.ɵɵelementEnd();
} }
const _c2 = function () { return []; };
function SessionInfoCardComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "h3", 57);
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵelement(3, "img", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵelement(6, "img", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 59);
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵelement(9, "span", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 11);
    i0.ɵɵelement(11, "span", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 14);
    i0.ɵɵelementStart(13, "div", 15);
    i0.ɵɵtemplate(14, SessionInfoCardComponent_div_3_button_14_Template, 1, 0, "button", 62);
    i0.ɵɵelementStart(15, "button", 63);
    i0.ɵɵlistener("click", function SessionInfoCardComponent_div_3_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.scheduleSession(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngIf", ctx_r2.session != null || ctx_r2.endedSessions != i0.ɵɵpureFunction0(1, _c2));
} }
const _c3 = function () { return ["fas", "star"]; };
const _c4 = function () { return ["far", "star"]; };
function SessionInfoCardComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 65);
    i0.ɵɵelementStart(1, "span", 66);
    i0.ɵɵelementStart(2, "em", 67);
    i0.ɵɵelement(3, "fa-icon", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "em", 69);
    i0.ɵɵelement(5, "fa-icon", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const fill_r43 = ctx.fill;
    i0.ɵɵclassProp("full", fill_r43 === 100);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", fill_r43, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(6, _c3));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(7, _c4));
} }
export class SessionInfoCardComponent {
    constructor(modalService, sessionService, userService, router, accountService, trackerService, languageService, sessionStatusManagerService) {
        this.modalService = modalService;
        this.sessionService = sessionService;
        this.userService = userService;
        this.router = router;
        this.accountService = accountService;
        this.trackerService = trackerService;
        this.languageService = languageService;
        this.sessionStatusManagerService = sessionStatusManagerService;
        this.timezone = momenttz.tz.guess();
        this.coachReasoningList = []; // contains languages
        this.endedSessions = [];
    }
    set session(value) {
        this._session = value;
        this.loadPage();
    }
    get session() {
        return this._session;
    }
    ngOnInit() {
        console.log(this.session);
    }
    ngOnChanges(changes) {
    }
    loadPage() {
        if (this.session != null) {
            let coachIds = [this.session.coachId];
            this.userService.getAllCoachReasoningsByCoachId(coachIds).subscribe(res => {
                this.coachReasoningList = res.body;
                this.supportedLanguages = this.coachReasoningList.map(r => r.lang).map(item => item === 'en' ? 'gb' : item);
            });
        }
    }
    goToSessionChat(session) {
        this.sessionStatusManagerService.navigateToSession(session);
    }
    cancelSession(sessionId, type) {
        const modalRef = this.modalService.open(CancelSessionDialogComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.sessionId = sessionId;
        modalRef.componentInstance.type = type;
    }
    scheduleSession() {
        this.trackerService.sendActivity("home_booksession_btn_clicked");
        this.router.navigate(['../session/schedule-session/']).then();
    }
    rescheduleSession(sessionId) {
        this.cancelSession(sessionId, 'reschedule');
    }
    getDisplayBlock() {
        let status = 'NONE';
        if (this.session != null && !this.session.cancelled) {
            status = this.session.statusOfSession;
        }
        return status;
    }
    getDisplayBlockForButtons() {
        let result = 'FUTURE';
        if (this.session.started)
            result = 'STARTED';
        else if (this.session.active)
            result = 'ACTIVE';
        return result;
    }
    openRating() {
        const modalRef = this.modalService.open(RateSessionComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.session = this.session != null ? this.session : this.endedSessions[0];
    }
}
SessionInfoCardComponent.ɵfac = function SessionInfoCardComponent_Factory(t) { return new (t || SessionInfoCardComponent)(i0.ɵɵdirectiveInject(i1.NgbModal), i0.ɵɵdirectiveInject(i2.SessionService), i0.ɵɵdirectiveInject(i3.UserService), i0.ɵɵdirectiveInject(i4.Router), i0.ɵɵdirectiveInject(i5.AccountService), i0.ɵɵdirectiveInject(i6.TrackerService), i0.ɵɵdirectiveInject(i7.JhiLanguageService), i0.ɵɵdirectiveInject(i8.SessionStatusManagerService)); };
SessionInfoCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionInfoCardComponent, selectors: [["session-info-card"]], inputs: { session: "session" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 3, consts: [[1, "olha-theme", 2, "height", "100%", 3, "ngSwitch"], ["class", "bg-1", 4, "ngSwitchCase"], ["class", "future-card", 4, "ngSwitchDefault"], ["t", ""], [1, "bg-1"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.talk", 1, "none-header"], [1, "d-flex", "justify-content-center", "d-lg-none"], ["src", "../../../../../content/images/inuka/talking.png", "alt", "talking.png", 1, "talking-image"], [1, "d-flex"], [1, "none-text"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.feelBetter"], [1, "mt-2"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.experienceYourself"], [1, "d-none", "d-lg-block", "d-xl-block"], [1, "mt-3", "mb-4", "h5"], [1, "d-flex", "justify-content-center"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.bookASession", 1, "btn", "btn-primary", "ended-reschedule", "session-info-schedule-new-session-btn", 3, "click"], [1, "future-card"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.yourUpcomingSession", 1, "mt-4", "mb-3"], [1, "justify-content-start", "align-items-center"], [1, "d-flex", "justify-content-start", "align-items-top", "mb-2"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.coach", 2, "flex", "0 0 20%"], [1, "d-flex", "justify-content-start", "align-items-center", "mr-2", 2, "font-weight", "bold"], [1, "font-weight-bold"], [1, "stars-outer", "align-items-center"], ["max", "5", 1, "ml-2", "mr-2", 3, "rate", "starTemplate", "readonly", "rateChange"], [1, "float-right"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.sessionType", 2, "flex", "0 0 20%"], [2, "height", "14px", "width", "14px", "margin-right", "4px", 3, "ngStyle"], [0, "xlink", "href", ""], [1, "font-weight-bold", 3, "jhiTranslate"], ["icon", "info-circle", 1, "ml-2", 2, "cursor", "pointer", "color", "#44A38B", 3, "matTooltip", "matTooltipPosition", "matTooltipClass"], [1, "d-flex", "justify-content-start", "align-items-top"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.language", 2, "flex", "0 0 20%"], [3, "emoji"], [1, "ml-1", "font-weight-bold"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.date", 2, "flex", "0 0 20%"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.time", 2, "flex", "0 0 20%"], [1, "d-flex", "justify-content-between", "align-items-center", 2, "flex-flow", "row wrap"], [1, "font-weight-bold", "mr-1"], [3, "session"], [1, "mt-2", "h5", 3, "ngSwitch"], ["class", "d-flex justify-content-center", 4, "ngSwitchCase"], [1, "d-md-none"], ["class", "btn future-cancel session-info-cancel-btn", "jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.cancel", 3, "click", 4, "ngIf"], ["class", "btn btn-secondary future-reschedule session-info-reschedule-session-btn", "jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.reschedule", 3, "click", 4, "ngIf"], [1, "d-none", "d-md-block", "d-lg-block", "d-xl-block"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.cancel", 1, "btn", "future-cancel", "session-info-cancel-btn", 3, "click"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.reschedule", 1, "btn", "btn-secondary", "future-reschedule", "session-info-reschedule-session-btn", 3, "click"], ["class", "btn active-reschedule session-info-reschedule-session-btn", "jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.reschedule", 3, "click", 4, "ngIf"], [1, "btn", "btn-primary", "active-join", "session-info-enter-session-btn", 3, "click"], ["class", "video-icon", "icon", "video", 4, "ngIf"], [3, "jhiTranslate"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.reschedule", 1, "btn", "active-reschedule", "session-info-reschedule-session-btn", 3, "click"], ["icon", "video", 1, "video-icon"], [1, "d-flex", "justify-content-center", "d-md-none"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.sessionStarted", 1, "session-started-text", 3, "translateValues"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.great", 1, "ended-header"], ["src", "../../../../../content/images/inuka/winner.png", "alt", "winner.png", 1, "winner-image"], [1, "ended-text"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.howWasIt"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.bookAnother"], ["class", "btn btn-link mr-2 mr-md-3", "jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.giveFeedback", 3, "click", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.bookASession", 1, "btn", "btn-primary", "session-info-schedule-new-session-btn", 3, "click"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.giveFeedback", 1, "btn", "btn-link", "mr-2", "mr-md-3", 3, "click"], [1, "star"], [1, "half"], [1, "inuka-green"], [3, "icon"], [1, "inuka-green", "cursor"]], template: function SessionInfoCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SessionInfoCardComponent_div_1_Template, 15, 0, "div", 1);
        i0.ɵɵtemplate(2, SessionInfoCardComponent_div_2_Template, 43, 33, "div", 2);
        i0.ɵɵtemplate(3, SessionInfoCardComponent_div_3_Template, 16, 2, "div", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, SessionInfoCardComponent_ng_template_4_Template, 6, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngSwitch", ctx.getDisplayBlock());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "NONE");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngSwitchCase", "ENDED");
    } }, directives: [i9.NgSwitch, i9.NgSwitchCase, i9.NgSwitchDefault, i10.JhiTranslateDirective, i1.NgbRating, i9.NgStyle, i11.FaIconComponent, i12.MatTooltip, i13.EmojiComponent, i14.AddToCalendarComponent, i9.NgIf], pipes: [i9.DecimalPipe, i15.TranslatePipe, i16.FindFlagCodeFromKeyPipe, i17.FindLanguageFromKeyPipe, i9.TitleCasePipe], styles: [".olha-theme[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-around;border-radius:20px !important;height:100%}.btn[_ngcontent-%COMP%]{min-width:140px !important}.btn-get-support[_ngcontent-%COMP%]{background-color:#000;border-radius:40px;width:150px;padding-top:3px !important;padding-bottom:3px !important}.future-card[_ngcontent-%COMP%]{background:#fff !important;padding-left:18px !important;padding-right:18px !important}.future-cancel[_ngcontent-%COMP%]{color:#44a38b !important;text-decoration:underline !important}.width-80[_ngcontent-%COMP%]{width:80px !important}.inuka-green[_ngcontent-%COMP%]{color:#44a38b !important}[_nghost-%COMP%] .info-tool-tip, [_nghost-%COMP%] .flag-tool-tip{color:#fff !important;background:#44a38b !important;border:1px solid #44a38b !important;overflow:visible !important}[_nghost-%COMP%]  .info-tool-tip:before{content:\"\";position:absolute;bottom:40%;left:-6px;border-bottom:5px solid transparent;border-top:5px solid transparent;border-right:5px solid #44a38b;z-index:10000}[_nghost-%COMP%]  .flag-tool-tip:before{content:\"\";position:absolute;bottom:-6px;left:40%;border-top:5px solid #44a38b;border-left:5px solid transparent;border-right:5px solid transparent;z-index:10000}.future-reschedule[_ngcontent-%COMP%]{color:#44a38b !important;padding:6px 0 !important;font-weight:bold !important}.ended-reschedule[_ngcontent-%COMP%]{color:#fff !important;padding:6px 0 !important;font-weight:bold !important}.active-join[_ngcontent-%COMP%]{font-weight:bold !important;padding:6px 0 !important;min-width:180px !important}.active-reschedule[_ngcontent-%COMP%]{color:#44a38b !important;text-decoration:underline;font-weight:bold !important;padding:0 !important}.desktop-calendar[_ngcontent-%COMP%]{position:relative;top:-3px;right:-170px}.star[_ngcontent-%COMP%]{position:relative;display:inline-block;font-size:1rem}.half[_ngcontent-%COMP%]{position:absolute;display:inline-block;overflow:hidden}.video-icon[_ngcontent-%COMP%]{color:#fff !important;padding-right:5px !important}.winner-image[_ngcontent-%COMP%]{width:93px !important;height:auto !important}.ended-text[_ngcontent-%COMP%], .session-started-text[_ngcontent-%COMP%]{padding-left:20px !important;padding-right:20px !important;text-align:center !important;font-family:\"Open Sans\",sans-serif !important}.none-text[_ngcontent-%COMP%]{padding-left:20px !important;text-align:center !important;font-family:\"Open Sans\",sans-serif !important;font-size:16px !important}.ended-header[_ngcontent-%COMP%], .none-header[_ngcontent-%COMP%]{padding:30px 0 9px 0 !important;text-align:center !important}add-to-calendar[_ngcontent-%COMP%]{margin-bottom:0 !important}.talking-image[_ngcontent-%COMP%]{width:133px !important;height:auto !important}@media(min-width: 768px){.future-card[_ngcontent-%COMP%]{padding-left:34px !important;padding-right:34px !important}.ended-text[_ngcontent-%COMP%]{padding-left:18px !important;padding-right:30px !important;text-align:left !important}.ended-header[_ngcontent-%COMP%]{padding:30px 30px 20px 30px !important;text-align:left !important}.none-header[_ngcontent-%COMP%]{padding:30px 30px 10px 30px !important;text-align:left !important}.none-text[_ngcontent-%COMP%]{padding-left:0 !important;margin-left:30px !important;text-align:left !important;width:222px !important}}@media(min-width: 992px){.winner-image[_ngcontent-%COMP%]{width:260px !important;height:auto !important;margin-left:22px !important}.talking-image[_ngcontent-%COMP%]{width:183px !important;height:auto !important}}"] });
